import {VideoScriptKind} from '@contentlab/api/avatars/types';

export interface ScriptTypeOption {
  id: VideoScriptKind;
  localeLabelKey: string;
}

export const SCRIPT_TYPE_OPTIONS: ScriptTypeOption[] = [
  {id: VideoScriptKind.HowTo, localeLabelKey: 'How-to'},
  {id: VideoScriptKind.Review, localeLabelKey: 'Review video'},
  {id: VideoScriptKind.ProblemSolution, localeLabelKey: 'Problem→Solution'},
  {id: VideoScriptKind.Testimonials, localeLabelKey: 'Testimonials'},
  {id: VideoScriptKind.Challenges, localeLabelKey: 'Challenges'},
];
